import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppDataService } from 'src/app/core/app-data/app-data.service';
import { SERIAL_NUMBER } from 'src/app/shared/api.constants';

@Injectable({
  providedIn: 'root',
})
export class SerialNumberService {
  constructor(private appDataService: AppDataService) {}

  public getEquipmentBySerialNumber(serialNo: string, is_view: boolean = true): Observable<any> {
    const queryParams = {
      provider: 'ESPP',
      serial_number: serialNo,
      indicator: 'V',
      is_view
    };
    return this.appDataService.get<any>(SERIAL_NUMBER, queryParams).pipe(
      catchError(error => {
        return of(error)
      })
    );
  }
  public getLongSerialNumber({serial_number, manufacturer}: {serial_number: string, manufacturer: string}): Observable<any> {
    const queryParams = {
      provider: 'CNH',
      serial_number,
      indicator: 'V',
      manufacturer
    }
    return this.appDataService.get<any>(SERIAL_NUMBER, queryParams);
  }
}
